export default {
  light: {
    header: '#fff',
    headerBorder: '#a7a7aa',
    body: '#fff',
    bodyBorder: '#a7a7aa',
    bodyContent: '#fff',
    label: 'rgba(0, 0, 0, 0.9)',
  },
  dark: {
    header: '#2a2a2a',
    headerBorder: '#3a3a3a',
    body: '#000',
    bodyBorder: '#343434',
    bodyContent: '#2a2a2a',
    label: '#fff',
  },
};
